import Button from '../../../../components/Button';
import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { useStorageDate } from '../../../../hooks/useStorageDate';
import { useTranslate } from '../../../../hooks/useTranslate';

import { FullDate, GreatHead, Main, Message, Success } from './styled';

export default function ExtendSuccess() {
  const { expDate } = useStorageDate();

  const { staticTranslate } = useTranslate();
  const { navigateWithUid } = useCustomNavigate();

  const toMainPage = () => {
    navigateWithUid('/', { replace: true });
  };

  return (
    <>
      <Main>
        <Success role="img" aria-label="Success image" />
        <GreatHead>{staticTranslate('OrderExtendSuccess')}</GreatHead>
        <Message>{staticTranslate('OrderExtendSuccess2')}</Message>
        <FullDate aria-label="Extension date">{expDate}</FullDate>
      </Main>
      <Button variant="outlined" onClick={toMainPage}>
        {staticTranslate('ToMain')}
      </Button>
    </>
  );
}
